<template>
  <div
      :class="[
        'image',
        selected && 'selected',
      ]"
      :data-uuid="node.attrs.uuid"
      contenteditable="false"
      draggable="true"
      @click="onClick">
    <div
        v-if="loading"
        class="message loading">
      Loading image...
    </div>
    <div
        v-else-if="error"
        class="message error">
      <div class="icon">image_not_supported</div>
      <div class="message-text">
        Could not load image
        <span
            v-if="node.attrs.type === 'local'"
            class="identifier">
          Image UUID: {{ node.attrs.uuid }}
        </span>
        <span
            v-else-if="node.attrs.type === 'remote'"
            class="identifier">
          Image source: {{ node.attrs.src }}
        </span>
      </div>
    </div>
    <img
        v-else-if="src"
        :src="src"
        :title="node.attrs.title"
        :alt="node.attrs.alt"
        @error="error = true">
  </div>
</template>

<script>
import { NodeSelection } from 'prosemirror-state';

export default {
  props: {
    node: {
      type: Object,
    },
    view: {
      type: Object,
    },
    selected: {
      type: Boolean,
    },
    getPos: {
      type: Function,
    },
    editor: {
      type: Object,
    },
  },
  data() {
    return {
      type: '',
      uuid: '',
      src: '',
      loading: true,
      error: false,
    };
  },
  created() {
    this.load();
  },
  beforeUpdate() {
    this.load();
  },
  methods: {
    async load() {
      const { type, uuid, src } = this.node.attrs;
      if (this.type !== type) {
        if (type === 'local') {
          this.loadLocal(uuid);
        } else if (type === 'remote') {
          this.loadRemote(src);
        }
      } else if (type === 'local' && this.uuid !== uuid) {
        this.loadLocal(uuid);
      } else if (type === 'remote' && this.src !== src) {
        this.loadRemote(src);
      }

      this.type = type;
    },
    async loadLocal(uuid) {
      this.error = false;
      this.src = '';
      const image = await this.$store.dispatch('images/get', { uuid });

      this.loading = false;
      this.uuid = uuid;
      if (image === undefined) {
        this.error = true;
        return;
      }
      this.src = image.data;
    },
    loadRemote(src) {
      this.error = false;
      this.loading = false;
      this.uuid = null;
      this.src = src;
    },
    onClick() {
      const { state } = this.view;
      let { tr } = state;
      const selection = NodeSelection.create(state.doc, this.getPos());
      tr = tr.setSelection(selection);
      this.view.dispatch(tr);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.image {
  display: flex;
  margin: 0.5rem;
  max-width: 60rem;
  position: relative;
  width: 100%;

  &.selected {
    outline: 0.125rem solid $primary-600;
  }

  img {
    width: 100%;
  }

  .message {
    border-radius: 0.25rem;
    padding: 1rem;
    text-align: center;
    width: 100%;

    &.loading {
      border: 0.0625rem solid $dark-gray-700;
    }

    &.error {
      align-items: center;
      border: 0.0625rem solid $red-800;
      color: $red-800;
      display: flex;

      .icon {
        margin: 0 1.25rem 0 0.5rem;
      }

      .message-text {
        min-width: 0;
        flex-grow: 1;

        span {
          display: block;
        }

        .identifier {
          color: $disabled-text;
          font-size: 0.625rem;
          font-style: italic;
        }
      }
    }
  }

}

</style>
